/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { createJingleCollectionItemModelSchema } from "./createJingleCollectionItemModelSchema.ts";
import { z } from "zod";

export const changeJingleOrderModelSchema = z.object({
    "items": z.array(z.lazy(() => createJingleCollectionItemModelSchema)).describe("Порядок джинглов")
    })